<template>
      <a-col>
        <div class="individual_device_container">
          <a-button block class="green_bg step_btn" size="large" @click.prevent="linkToApp">前往APP</a-button>
          <a-modal v-model="visible" title="是否導向iTRAQ APP?" class="msg_confirm_modal with-cancel-btn" @ok="handleOk" okText="前往APP" cancelText="否">
            <p>裝置已納管</p>
          </a-modal>
        </div>
      </a-col>
</template>

<script>
    export default {
        name: 'IndividualDeviceInfoButton',
        data() {
            return {
              visible: false
            }
        },
        methods: {
            handleOk() {
              this.visible = false;
              // todo 改為導向 iTRAQ App
              window.location.href = `${process.env.VUE_APP_FMS_URL}/register/step1`
            },
            linkToApp() {
              this.visible = true;
            }
        },
    }
</script>

<style lang="scss" scoped>
  .individual_device_container {
      margin-top: 51px;
      padding: 0 13px 12px 13px;
  }
</style>